// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__34Fik","label":"Section_label__10PVr","contentWrap":"Section_contentWrap__4jqar","footer":"Section_footer__3bten","footerInner":"Section_footerInner__1_m4V"};